import React, { useEffect } from "react";

export default function RedirectScreen({ theme }) {
  const partner = localStorage.getItem("partnerIdentifier");
  const redirectionUrls = {
    housr: {
      playStore: "https://play.google.com/store/apps/details?id=com.crib.housr",
      appStore: "https://apps.apple.com/in/app/housr/id6566186133",
    },
  };

  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    if (/android/i.test(userAgent)) {
      // Redirect to Google Play Store for Android
      window.location.href = redirectionUrls?.[partner].playStore;
    } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      // Redirect to Apple App Store for iOS
      window.location.href = redirectionUrls?.[partner].appStore; // Replace with your App Store link
    } else {
      // Optional: If on desktop or an unsupported device, display a message
      // alert('Please open this link on a mobile device to download the app.');
      window.location.href = redirectionUrls?.[partner].playStore;
    }
  }, []);

  return (
    <div className="flex w-full h-full items-center justify-centers">
      Going back to {partner}...
    </div>
  );
}
